import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ButtonBlockFragment } from '../button-block'
import { FaqsBlockFragment } from '../faqs-block'
import { HeadingBlockFragment } from '../heading-block'
import { HtmlBlockFragment } from '../html-block'
import { ImageBlockFragment } from '../image-block'
import { JumpToLinksBlockFragment } from '../jump-to-links-block'
import { ReferFriendBlockFragment } from '../refer-friend-block'
import { RichTextBlockFragment } from '../rich-text-block'
import { ShareLinkBlockFragment } from '../share-link-block'
import { SpacerBlockFragment } from '../spacer-block'
import { VideoBlockFragment } from '../video-block'
import { ViewableBy } from '../utilities/viewable-check'

export const ColumnLayoutBlockFragment: BlockFragment = {
  name: 'columnLayout',
  fragment: gql`
    fragment columnLayout on ColumnLayout {
      id
      blockName
      blockType
      columns {
        content {
          ${ButtonBlockFragment.partialFragment}
          ${FaqsBlockFragment.partialFragment}
          ${HeadingBlockFragment.partialFragment}
          ${HtmlBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${ReferFriendBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${ShareLinkBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
          ${VideoBlockFragment.partialFragment}
        }
      }
      columnLayoutMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
    `,
  partialFragment: `
    ...on ColumnLayout {
      id
      blockName
      blockType
      columns {
        content{
          ${ButtonBlockFragment.partialFragment}
          ${FaqsBlockFragment.partialFragment}
          ${HeadingBlockFragment.partialFragment}
          ${HtmlBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${ReferFriendBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${ShareLinkBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
          ${VideoBlockFragment.partialFragment}
        }
      }
      columnLayoutMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
    `,
}

export const ColumnLayoutBlockType = 'columnLayout'

export interface ColumnLayoutBlock extends BaseBlock {
  blockType: typeof ColumnLayoutBlockType
  columns: {
    id: string
    content: BaseBlock[]
  }[]
  columnLayoutMeta?: {
    viewableBy: [ViewableBy]
  }
}
